import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import styles from './PerksModal.module.scss';

import { Modal } from 'components/Modal';
import { ModalHeader } from 'components/ModalHeader/ModalHeader';
import { useCloseNavigate } from 'hooks/useCloseNavigate/useCloseNavigate';
import { RouteFC } from 'util/routeTypes';
import { PERKS_MODAL } from './PerksModal.const';
import { usePerks } from 'hooks/context/Perks';
import { PerkCard } from './PerkCard';
import { isScheduledPerk, generateScheduledPerkContent } from '../util/Perk.util';

import { useMerchantState } from 'hooks/context/MerchantState';
import { useMerchant } from 'hooks/context/merchant';
import { ShimmerCard } from './ShimmerCard/ShimmerCard';

export const PerksModal: RouteFC = ({ path }) => {
  const { t } = useTranslation();
  const { availablePerks, inProgressPerks, isLoading } = usePerks();
  const { merchant } = useMerchant();
  const { showPerksState } = useMerchantState();
  const onClose = useCloseNavigate(path);

  useEffect(() => {
    if (!isLoading && availablePerks.length === 0 && inProgressPerks.length === 0) {
      onClose();
    }
  }, [onClose, isLoading, availablePerks.length, inProgressPerks.length, showPerksState]);

  if (!showPerksState || (!isLoading && availablePerks.length === 0 && inProgressPerks.length === 0)) return null;

  const showPerksSubtitle = availablePerks.length > 0;

  return (
    <Modal
      contentLabel={PERKS_MODAL.root}
      testId={PERKS_MODAL.root}
      isOpen
      className={styles.modal}
      onClose={onClose}
    >
      <ModalHeader onClose={onClose} data-testid={PERKS_MODAL.title} id={PERKS_MODAL.id}>{t('perks.title')}</ModalHeader>
      <div className={styles.container} >
      {isLoading ? Array.from(Array(3).keys()).map((i) => <ShimmerCard key={i} className={styles.card} />) :
       <>
        {showPerksSubtitle && <div className={styles.subtitle}>{t('perks.availableSubtitle')}</div>}
        {(availablePerks.length !== 0 ) && <div className={styles.perkSection}>
          <h3>{t('perks.availablePerksMenu')}</h3>
            {availablePerks.map((perk) => (
              <PerkCard
                key={perk.uuid}
                perk={perk}
                scheduledPerkContent={merchant && generateScheduledPerkContent(perk, merchant)}
                disabled={merchant && isScheduledPerk(perk, merchant)}
              />
            ))}
          </div>
            }
            {inProgressPerks.length !== 0 && <div className={styles.perkSection}>
          <h3>{t('perks.inProgressPerks')}</h3>
          {inProgressPerks.map(perk => (<PerkCard key={perk.uuid} perk={perk} showPerkProgress />))}
        </div>}
        </>}
      </div>
    </Modal>
  );
};
